export const couplingPatterns = [
    's',
    'd',
    't',
    'q',
    'quint',
    'h',
    'sept',
    'o',
    'n',
];
//# sourceMappingURL=couplingPatterns.js.map